import { type FC } from "react";

export const ChartTabSkeleton: FC = () => null;
